import { Loadable } from '../../Loadable';

export const AsyncAddFulfillmentCenter = Loadable(() => import('./Add'));
export const AsyncEditFulfillmentCenter = Loadable(() => import('./Edit'));
export const AsyncTestDeliveryFormat = Loadable(() => import('./TestDeliveryFormat'));
export const AsyncFulfillmentCenterMenu = Loadable(() => import('./Menu'));
export const AsyncFulfillmentCenterMarkItemAsSoldout = Loadable(() => import('./MarkItemAsSoldout'));
